var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPolicy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M34.5940552,41.6699219H15.4104614c-2.3388672,0-4.2421875-1.9033203-4.2421875-4.2421875v-24.855957 c0-2.3388672,1.9033203-4.2416992,4.2421875-4.2416992h19.1835938c2.3388672,0,4.2421875,1.902832,4.2421875,4.2416992v24.855957 C38.8362427,39.7666016,36.9329224,41.6699219,34.5940552,41.6699219z M15.4104614,10.3300781 c-1.2363281,0-2.2421875,1.0058594-2.2421875,2.2416992v24.855957c0,1.2363281,1.0058594,2.2421875,2.2421875,2.2421875h19.1835938 c1.2363281,0,2.2421875-1.0058594,2.2421875-2.2421875v-24.855957c0-1.2358398-1.0058594-2.2416992-2.2421875-2.2416992H15.4104614 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M31.2161255,18.5888672H18.7883911c-0.5527344,0-1-0.4477539-1-1s0.4472656-1,1-1h12.4277344 c0.5527344,0,1,0.4477539,1,1S31.7688599,18.5888672,31.2161255,18.5888672z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M31.2161255,24.2421875H18.7883911c-0.5527344,0-1-0.4477539-1-1s0.4472656-1,1-1h12.4277344 c0.5527344,0,1,0.4477539,1,1S31.7688599,24.2421875,31.2161255,24.2421875z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M25.0022583,29.8955078h-6.2138672c-0.5527344,0-1-0.4472656-1-1s0.4472656-1,1-1h6.2138672 c0.5527344,0,1,0.4472656,1,1S25.5549927,29.8955078,25.0022583,29.8955078z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPolicy);
export default __webpack_public_path__ + "static/media/icon_policy.068a4e94c297564884e88571e4833c57.svg";
export { ForwardRef as ReactComponent };